import React, { useState, useEffect, useRef } from 'react';
import { Button, Table, Carousel, Empty, message, Popover, Dropdown, Select, Spin } from 'antd';
import { useHistory } from 'react-router-dom';
import { RightOutlined, QuestionCircleOutlined } from '@ant-design/icons';
import moment from 'moment';//日期格式化导包
import { Config } from '../../public/js/config';
import { Base } from '../../public/js/base';
import context from '../../public/js/context';
import { ContextHandler } from '../../public/js/contextHandler';
import NewMessage from '../../component/newMessage/newMessage';
import { partnerCheckLogin } from '../newMain/partnerMain';
import PartnerJobSort from './partnerJobSort';
import MessageConfirm from '../../component/messageConfirm/messageConfirm';
import './partnerHome.css';

import vectorImg from '../../public/img/newMain/Vector.png';
import sortImg from '../../public/img/newMain/Sort.png';
import resetImg from '../../public/img/newMain/Reset.png';
import createImg from '../../public/img/newMain/Create.png';
import duplicateImg from '../../public/img/newMain/Duplicate.png';
import deleteIcon from '../../public/img/newMain/deleteIcon.png';
import inspectImg from '../../public/img/newMain/Inspect.png';
import studentImg from '../../public/img/newMain/Student.png';
import rightArrow from '../../public/img/newMain/RightArrow.png';
import leftArrow from '../../public/img/newMain/leftArrow.png';
import exportImg from '../../public/img/newMain/Export.png';
import searchImg from '../../public/img/newMain/Search.png';
import select1 from '../../public/img/std/select1.png';
import select3 from '../../public/img/std/select3.png';
import select5 from '../../public/img/std/select5.png';
import studentDefaultPictureImg from '../../public/img/newMain/studentDefaultPicture.png'
import fillImg from '../../public/img/std/fill.png'

const PartnerHome = (props) => {
    const messageRef = useRef();
    const history = useHistory();
    const carouselRef = useRef();
    const carouselRef2 = useRef();
    const carouselRef3 = useRef();
    const messageConfirmRef = useRef();
    const [tables, setTables] = useState([]);
    const [tablesCount, setTablesCount] = useState(0);
    const [current, setCurrent] = useState(1);
    const [pageSize, setPageSize] = useState(10);
    const [jobPostNum, setJobPostNum] = useState(0);
    const [draftNum, setDraftNum] = useState(0);
    const [submittedNum, setSubmittedNum] = useState(0);
    const [activeNum, setActiveNum] = useState(0);
    const [rejectedNum, setRejectedNum] = useState(0);
    const [expiredNum, setExpiredNum] = useState(0);
    const [withdrawnNum, setWithdrawnNum] = useState(0);

    const [draftList, setDraftList] = useState([]);
    const [submittedList, setSubmittedList] = useState([]);
    const [activeList, setActiveList] = useState([]);
    const [draftOriginList, setDraftOriginList] = useState([]);
    const [submittedOriginList, setSubmittedOriginList] = useState([]);
    const [activeOriginList, setActiveOriginList] = useState([]);
    const [partnerContactModel, setPartnerContactModel] = useState({});
    const [jobTitle, setJobTitle] = useState("");
    const [jobApplNum, setJobApplNum] = useState(0);
    const [receivedNum, setReceivedNum] = useState(0);
    const [appliedNum, setAppliedNum] = useState(0);
    const [documentNum, setDocumentNum] = useState(0);
    const [offerPendRespNum, setOfferPendRespNum] = useState(0);
    const [offerPendReviewNum, setOfferPendReviewNum] = useState(0);

    const [popoverVisible, setPopoverVisible] = useState(false);
    const [isReset, setIsReset] = useState(false);
    const [jobSortPostModel, setJobSortPostModel] = useState({});
    const [isLoad, setIsLoad] = useState(false);
    const [jobSearchType, setJobSearchType] = useState("ALL");
    const [jobApplSearchType, setJobApplSearchType] = useState("ALL");
    const [jobSearchTypeList, setJobSearchTypeList] = useState([
        { label: 'All', value: 'ALL' },
        { label: 'Last 12 Months', value: 'YEAR' }
    ]);
    const [jobApplSearchTypeList, setJobApplSearchTypeList] = useState([
        { label: 'All', value: 'ALL' },
        { label: 'Last 12 Months', value: 'YEAR' }
    ]);
    const [withdrawnModel, setWithdrawnModel] = useState({});

    const [withdrawnMessage, setWithdrawnMessage] = useState("You are cancelling an active job post, which will terminate all in-progress job applications. Job applications that have received an offer will not be affected. To halt new job applications without impacting those in progress, you can modify the 'Application Deadline' date. Please confirm if you want to proceed with withdrawing the job post.")
    const [size, setSize] = useState(0);
    const [isFirstShow, setIsFirstShow] = useState(true);
    const [isFirstRender, setIsFirstRender] = useState(true);
    const [orderByModel, setOrderByModel] = useState({});

    useEffect(() => {
        if (!Config.partnerInfo?.partnerId) {
            partnerCheckLogin();
        }
        const changePwdDate = Config.userInfo?.changePwdDate;
        if (!changePwdDate || Date.now() - moment(changePwdDate) >= 180 * 24 * 60 * 60 * 1000) {
            Config.userInfo.operationFlag = true;
            history.push('/partner/partnerChangePassword');
        }
        handleResize();
        window.addEventListener('resize', handleResize);
        searchPartnerContact();
        searchJobCount();
        searchJobApplCount();
        searchApplList(10, 1);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        if (isFirstRender) {
            setIsFirstRender(false);
            return;
        }
        if (isFirstShow) {
            searchJobList();
            setIsFirstShow(false)
        } else {
            let draftListNew = processingdata(draftOriginList);
            let submittedListNew = processingdata(submittedOriginList);
            let activeListNew = processingdata(activeOriginList);
            setDraftList(draftListNew);
            setSubmittedList(submittedListNew);
            setActiveList(activeListNew);
        }
    }, [size]);

    const handleResize = () => {
        if (window.innerWidth <= 1408) {
            setSize(4)
        } else (
            setSize(3)
        )
    };

    const searchPartnerContact = () => {
        Base.callBackApi("partnerHome/searchPartnerContact", {'partnerId': Config.partnerInfo?.partnerId}).then((data) => {
            if ("SUCCESS" === data.msg) {
                setPartnerContactModel(data.object);
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { });
    }

    const searchJobCount = (param) => {
        let model = {
            partnerId: Config.partnerInfo?.partnerId,
            jobSearchType: param ?? ""
        }
        Base.callBackApi("partnerHome/searchJobCount", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setJobPostNum(data.object?.jobPostNum ?? 0);
                setDraftNum(data.object?.draftNum ?? 0);
                setSubmittedNum(data.object?.submittedNum ?? 0);
                setActiveNum(data.object?.activeNum ?? 0);
                setRejectedNum(data.object?.rejectedNum ?? 0);
                setExpiredNum(data.object?.expiredNum ?? 0);
                setWithdrawnNum(data.object?.withdrawnNum ?? 0);
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { });
    }

    const searchJobList = (param, jobModel) => {
        let model = {};
        if (jobSortPostModel) {
            model = { ...jobSortPostModel }
        }
        if (jobModel) {
            model = { ...jobModel }
        }
        model.partnerId = Config.partnerInfo?.partnerId;
        model.jobTitle = param;
        Base.callBackApi("partnerHome/searchJobList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                let draftList = data.object?.draftList ?? [];
                let submittedList = data.object?.submittedList ?? [];
                let activeList = data.object?.activeList ?? [];
                setDraftOriginList(draftList);
                setSubmittedOriginList(submittedList);
                setActiveOriginList(activeList);
                let draftListNew = processingdata(draftList);
                let submittedListNew = processingdata(submittedList);
                let activeListNew = processingdata(activeList);
                setDraftList(draftListNew);
                setSubmittedList(submittedListNew);
                setActiveList(activeListNew);
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { });
    }

    const searchJobApplCount = (param) => {
        let model = {
            partnerId: Config.partnerInfo?.partnerId,
            jobSearchType: param ?? ""
        }
        Base.callBackApi("partnerHome/searchJobApplCount", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setJobApplNum(data.object?.jobApplNum ?? 0);
                setReceivedNum(data.object?.receivedNum ?? 0);
                setAppliedNum(data.object?.appliedNum ?? 0);
                setDocumentNum(data.object?.documentNum ?? 0);
                setOfferPendRespNum(data.object?.offerPendRespNum ?? 0);
                setOfferPendReviewNum(data.object?.offerPendReviewNum ?? 0);
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { });
    }

    const processingdata = (draftList) => {
        let draftListNew = [];
        let index = 0;
        for (var i = 0; i < draftList.length; i += size) {
            draftListNew[index] = []
            for (var j = 0; j < size; j++) {
                let item = draftList[i + j]
                if (item) {
                    draftListNew[index][j] = item
                }
            }
            index++
        }
        return draftListNew;
    }

    const searchApplList = (pageSizeNew, currentPageNew) => {
        let model = orderByModel;
        model.page = currentPageNew;
        model.startRow = (currentPageNew - 1) * pageSizeNew;
        model.pageSize = pageSizeNew;
        model.jobApplStatusList = ['PEND_IP_RECEIPT', 'IP_PROCESSING', 'REQUEST_DOCUMENT', 'DOCUMENT_ATTACHED', 'OFFER', 'OFFER_DECLINED', 'IN_PROGRESS'];
        model.partnerId = Config.partnerInfo?.partnerId;
        model.flag = 'Y';
        Base.callBackApi("partnerHome/searchApplList", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                setTables(data?.object?.list ?? []);
                setTablesCount(data?.object?.total ?? 0);
                setCurrent(currentPageNew);
                setPageSize(pageSizeNew);
            } else {
                message.error(data?.msg)
            }
        }).catch(err => { });
    }

    const reset = () => {
        setJobTitle("");
        setJobSortPostModel({})
        setIsReset(true)
        searchJobList("", {});
    }

    const handleOpenChange = (newOpen) => {
        setPopoverVisible(newOpen);
    };

    const handleOpenChange2 = (newOpen, status, jobSortJobPostModel) => {
        if (status) {
            setJobSortPostModel(jobSortJobPostModel)
            searchJobList(jobTitle, jobSortJobPostModel)
        }
        setIsReset(false)
        setPopoverVisible(newOpen);
    };

    const jump = (path) => {
        localStorage.removeItem("partnerDuplicateJobId");
        history.push(path);
    }

    const draftHandleSwitch = () => {
        carouselRef.current.next();
    }

    const submittedHandleSwitch = () => {
        carouselRef2.current.next();
    }

    const activeHandleSwitch = () => {
        carouselRef3.current.next();
    }

    //分页 页码切换变化查询
    const onChange = (currentNew, pageSizeNew) => {
        searchApplList(pageSizeNew, currentNew);
    }

    //分页 每页條數变化查询
    const onShowSizeChange = (currentNew, pageSizeNew) => {
        searchApplList(pageSizeNew, 1);
    }

    const jumpAppl = (record) => {
        localStorage.removeItem("partnerDuplicateJobId");
        history.push("/partner/partnerReviewStudentApplication/" + record.jobApplId);
    }

    const jumpDuplicate = (jobId) => {
        localStorage.setItem('partnerDuplicateJobId', jobId);
        history.push("/partner/partnerCreateJobPosting");
    }

    const saveSubmit = (record) => {
        if (isLoad) {
            return;
        }
        let model = record;
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("jobPost/submit", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                opendialog("You've successfully created a job posting. Please wait for the module convener to approve the job posting before it can be published.");
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const deleteJob = (record) => {
        if (isLoad) {
            return;
        }
        let model = record;
        model.menuFuncId = Config.funcInfo.funcId;
        setIsLoad(true);
        Base.callBackApi("jobPost/delete", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                opendialog("You've successfully deleted a job posting.");
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const saveWithdrawn = () => {
        if (isLoad) {
            return;
        }
        let model = {};
        model.menuFuncId = Config.funcInfo.funcId;
        model.jobId = withdrawnModel.jobId;
        model.lastUpdatedDate = withdrawnModel.lastUpdatedDate;
        setIsLoad(true);
        Base.callBackApi("jobPost/withdrawn", model).then((data) => {
            if ("SUCCESS" === data.msg) {
                messageConfirmRef.current.setIsShow(false);
                opendialog("You've successfully withdrawn a job posting.");
            } else {
                message.error(data.msg);
            }
        }).catch(err => { }).finally(() => setIsLoad(false));
    }

    const messageConfirmShow = (msg, record) => {
        setWithdrawnModel(record)
        messageConfirmRef.current.setContent(msg)
        messageConfirmRef.current.setIsShow(true)
        messageConfirmRef.current.setFlag(record.jobPostStatus)
    }

    const withdrawnDone = (flag) => {
        if (flag) {
            saveWithdrawn()
        } else {
            messageConfirmRef.current.setIsShow(false);
        }
    }

    const opendialog = (param) => {
        messageRef.current.setContent(param)
        messageRef.current.setIsShow(true)
    }

    const done = () => {
        messageRef.current.setIsShow(false);
        searchJobCount();
        searchJobApplCount(jobApplSearchType);
        searchJobList(jobTitle);
        searchApplList(10, 1);
    }

    const changeJobSearchType = (value) => {
        // let index = typeList.findIndex(item => item.value == value);
        // let list = JSON.parse(JSON.stringify(typeList));
        // list.splice(index, 1);
        // setJobSearchTypeList(list);
        setJobSearchType(value);
        searchJobCount(value);
    }

    const changeJobApplSearchType = (value) => {
        // let index = typeList.findIndex(item => item.value == value);
        // let list = JSON.parse(JSON.stringify(typeList));
        // list.splice(index, 1);
        // setJobApplSearchTypeList(list);
        setJobApplSearchType(value);
        searchJobApplCount(value);
    }

    const jobTitleChange = (value) => {
        setJobTitle(value)
        searchJobList(value, jobSortPostModel)
    }

    const tableColumns = {
        jobId: "job_id",
        jobTitle: "job_title",
        progTitle: "prog_title",
        jobPostStatus: "job_post_status",
        studentAcctId: "student_acct_id",
        firstName: "first_name",
        applyDate: "apply_date",
        jobApplStatus: "job_appl_status",
        attentionNeeded: "attention_needed",
    }

    const handleTableChange = (pagination, filters, sorter) => {
        let orderBy = "";
        if (sorter.field) {
            if (sorter.order === "ascend") {
                orderBy = tableColumns[sorter.field];
            } else if (sorter.order === "descend") {
                orderBy = tableColumns[sorter.field] + " DESC";
            }
        }
        if (!!sorter.field || !!orderByModel.orderBy) {
            if (orderBy !== orderByModel.orderBy) {
                orderByModel.orderBy = orderBy;
                searchApplList(10, 1);
            }
        }
    }
    
    /*eslint-disable*/
    const columns = [
        {
            title: 'Job ID',
            dataIndex: 'jobId',
            className: 'tableWidth8',
            render: text => text ? '#' + text : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobId') },
        },
        {
            title: 'Job Title',
            dataIndex: 'jobTitle',
            className: 'tableWidth19',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobTitle') },
        },
        {
            title: 'Job Post Status',
            dataIndex: 'jobPostStatus',
            className: 'tableWidth12',
            render: (text) => ContextHandler.getMapValue('jobPostStatusMap', text),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobPostStatus') },
        },
        {
            title: 'THEi Programme',
            dataIndex: 'progTitle',
            className: 'tableWidth20',
            render: text => (
                <Popover content={text} title="" trigger="hover">
                    <div className='tableProgramme'>{text}</div>
                </Popover>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'progTitle') },
        },
        {
            title: 'Student ID',
            dataIndex: 'studentAcctId',
            className: 'tableWidth11',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'studentAcctId') },
        },
        {
            title: 'Student',
            className: 'tableWidth11',
            render: (text, record) => <div>{record.firstName + " " + record.lastName}</div>,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'firstName') },
        },
        {
            title: 'Date Applied',
            dataIndex: 'applyDate',
            className: 'tableWidth10',
            render: text => text ? moment(text).format(Config.dateFormatEn) : '',
            sorter: (a, b) => { return Base.sortMethod(a, b, 'applyDate') },
        },
        {
            title: 'Status',
            dataIndex: 'jobApplStatus',
            width: 180,
            render: text => (
                <div className='tableStatusBox'>
                    {context.partnerJobApplStatusMap.map(item => item.value === text && <div className={'tableStatus ' + item.value}>
                        {item.label}
                    </div>)}
                </div>
            ),
            sorter: (a, b) => { return Base.sortMethod(a, b, 'jobApplStatus') },
        },
        {
            title: 'Attention Needed',
            dataIndex: 'attentionNeeded',
            className: 'tableWidth10',
            render: (text) => <div className='newInfoStyle'>{ContextHandler.getMapValue('attentionNeededMap', text)}</div>,
            sorter: (a, b) => { return Base.sortMethod(a, b, 'attentionNeeded') },
        },
        {
            title: 'Action',
            dataIndex: '',
            fixed: 'right',
            width: 80,
            render: (text, value) => (
                <div className='tableAction' onClick={() => jumpAppl(value)}><img src={exportImg} /></div>
            )
        },
    ];
    /*eslint-enable*/

    return (
        <div id="container" className='websiteTemplate partnerHome'>
            {/* <div className='backgroundBox'>
                <div className='backgorundTitle'>Welcome Back! {Config.partnerInfo?.contactName} @{Config.partnerInfo?.companyName}</div>
            </div> */}
            <NewMessage ref={messageRef} done={done} />
            <MessageConfirm ref={messageConfirmRef} done={withdrawnDone} />
            <Spin size="large" spinning={isLoad} >
                <div className='overviewRow'>
                    <div className='overviewBox'>
                        <div className='flexBox homeTitle'>Job Postings Overview</div>
                        <div className='jobPostingsOverview'>
                            <div className='searchDivCol'>
                                <Select
                                    value={jobSearchType}
                                    // options={jobSearchTypeList}
                                    onChange={(value) => changeJobSearchType(value)}
                                >
                                    {jobSearchTypeList.map((item) => <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>)}
                                </Select>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllJobPosting/all')}>
                                <div className='label'>Job Postings</div>
                                <div className='value selectRowValue'>{jobPostNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllJobPosting/DRAFT')}>
                                <div className='label'>Draft</div>
                                <div className='value selectRowValue'>{draftNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllJobPosting/SUBMITTED')}>
                                <div className='label'>THEi Reviewing</div>
                                <div className='value selectRowValue'>{submittedNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllJobPosting/REJECTED')}>
                                <div className='label'>THEi Rejected</div>
                                <div className='value selectRowValue'>{rejectedNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllJobPosting/ACTIVE')}>
                                <div className='label'>Active</div>
                                <div className='value selectRowValue'>{activeNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllJobPosting/EXPIRED')}>
                                <div className='label'>Expired</div>
                                <div className='value selectRowValue'>{expiredNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllJobPosting/WITHDRAWN')}>
                                <div className='label'>Withdrawn</div>
                                <div className='value selectRowValue'>{withdrawnNum}<RightOutlined /></div>
                            </div>
                        </div>
                    </div>
                    <div className='overviewBox'>
                        <div className='flexBox homeTitle'>Job Applications Overview</div>
                        <div className='jobApplicationsOverview'>
                            <div className='searchDivCol'>
                                <Select
                                    value={jobApplSearchType}
                                    // options={jobSearchTypeList}
                                    onChange={(value) => changeJobApplSearchType(value)}
                                >
                                    {jobApplSearchTypeList.map((item) => <Select.Option key={item.value} value={item.value}>{item.label}</Select.Option>)}
                                </Select>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllApplications/all')}>
                                <div className='label'>Total Job Applications</div>
                                <div className='value selectRowValue'>{jobApplNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllApplications/receipt')}>
                                <div className='label'>New Applications Pending Receipt</div>
                                <div className='value selectRowValue'>{appliedNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllApplications/processed')}>
                                <div className='label'>Application Being Processed</div>
                                <div className='value selectRowValue'>{receivedNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllApplications/document')}>
                                <div className='label'>Student Updated Information Pending Review</div>
                                <div className='value selectRowValue'>{documentNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllApplications/offer')}>
                                <div className='label'>Offer Pending Student Response</div>
                                <div className='value selectRowValue'>{offerPendRespNum}<RightOutlined /></div>
                            </div>
                            <div className='flexBox selectRow' onClick={() => jump('/partner/partnerSeeAllApplications/offerReview')}>
                                <div className='label'>Student Response to Offer Pending Review</div>
                                <div className='value selectRowValue'>{offerPendReviewNum}<RightOutlined /></div>
                            </div>
                        </div>
                    </div>
                    <div className='overviewBox'>
                        <div className='flexBox homeTitle'>Company Profile</div>
                        <div className='companyApplyingThree'>
                            <div className='companyApplyingThreeTopb'>
                                <img src={vectorImg} onClick={() => jump('/partner/partnerDetail')} />
                                <div className='companyApplyingThreeCentre'>
                                    <img src={Config.partnerInfo?.companyLogo ? Config.partnerImg + Config.partnerInfo?.companyLogo + '?' + Config.sasToken : studentDefaultPictureImg} />
                                </div>
                            </div>
                            <div className='companyApplyingThreeBottomBox'>
                                <div className='companyApplyingThreeBottomTitle cardTitle' title={Config.partnerInfo?.companyName}>
                                    {Config.partnerInfo?.companyName}
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Office Address</div>
                                    <div className='value ellipsisValue' title={Config.partnerInfo?.companyLocation}>{Config.partnerInfo?.companyLocation}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Website</div>
                                    <div className='value ellipsisValue'>{Config.partnerInfo?.companyWebsite}</div>
                                </div>
                                {/* <div className='flexBox'>
                                <div className='label'>Overview</div>
                                <div className='value companyProfile' id="companyProfile"></div>
                            </div> */}
                                <div className='flexBox'>
                                    <div className='label'>Date Last Job Post</div>
                                    <div className='value'>{partnerContactModel.dateOfLastJobPost ? moment(partnerContactModel.dateOfLastJobPost).format(Config.dateFormatEn) : ''}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Industry Partner ID</div>
                                    <div className='value'>{partnerContactModel?.partnerContactAcctId}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Name</div>
                                    <div className='value ellipsisValue'>{partnerContactModel?.contactName}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Email</div>
                                    <div className='value'>{partnerContactModel?.contactEmail}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Office Phone</div>
                                    <div className='value'>{partnerContactModel?.contactOfficePhone}</div>
                                </div>
                                <div className='flexBox'>
                                    <div className='label'>Mobile</div>
                                    <div className='value'>{partnerContactModel?.contactMobilePhone}</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <div className='flexTitleBox'>
                    <div className='homeTitle'>Manage Open Status Job Postings</div>
                    <div className='seeAllBox' onClick={() => jump('/partner/partnerSeeAllJobPosting/all')}>See all job postings</div>
                </div>
                <div className='websiteSysSearchRow' style={{ marginTop: '0px' }}>
                    <div className='websiteSysSearchBar'>
                        <input style={{ paddingLeft: '11px' }} placeholder="Search By programme, job title or by job ID"
                            value={jobTitle || ''}
                            onKeyDown={(e) => e.key === "Enter" ? searchJobList(jobTitle, jobSortPostModel) : null}
                            onChange={(e) => jobTitleChange(e.target.value)} />
                        <img src={searchImg} onClick={() => searchJobList(jobTitle, jobSortPostModel)} />
                    </div>
                    <Popover placement="topRight" trigger="click" open={popoverVisible}
                        onOpenChange={handleOpenChange} content={
                            <PartnerJobSort isReset={isReset} onOpenChange={handleOpenChange2} />
                        }
                        getPopupContainer={() => document.getElementById('sortButton')}
                    >
                        <div className='websiteSysButton sortButton' id='sortButton'><img src={sortImg} />Sort</div>
                    </Popover>
                    <div className='websiteSysButton sortButton' onClick={reset}><img src={resetImg} />Reset</div>
                    <div className='websiteSysButton createButton' onClick={() => jump('/partner/partnerCreateJobPosting')}><img src={createImg} />Create Job Posting</div>
                </div>

                {/* <div className='statusTitleBox'>
                <div className='statusTitleMax' style={{ backgroundColor: '#CDE7FF', color: '#0059AC' }}>
                    Ended
                </div>
            </div>
            <div className='jobPostingsRow'>
                <div className='jobPostingsCardBox'>
                    <div className='jobPostingsCardNew marginRight' style={{ borderLeft: '10px solid #FFC168' }}>
                        <div className='jobPostingsCardTop'>
                            <div className='stdPostingsCardRow'>
                                <div className='stdPositionBox'>
                                    <div className='dotBox'>
                                        <div className='dotIcon' style={{ backgroundColor: '#FFC168' }}></div>
                                    </div>
                                    <div className='stdPositionBoxTitle'>Product Design</div>
                                </div>
                            </div>
                            <div className='jobPostingsCardRow'>Job ID #678888</div>
                            <div className='jobPostingsCardRow'>
                                <div className='jobPostingsInfoBox'>
                                    <span>Interactive Product Designer</span>
                                    <div className='dateBox'>
                                        <div>
                                            <div>Commence</div>
                                            <span>05 Jul 2023</span>
                                        </div>
                                        <div>
                                            <div>End</div>
                                            <span>05 Sep 2023</span>
                                        </div>
                                    </div>
                                    <div>Application Deadline: <span style={{ color: "#000000" }}>20 Jan 2023</span></div>
                                </div>
                                <div className='vacancyBox'>
                                    <div className='vacancyDot' style={{color: '#D71920', borderColor: '#FFE4E3'}}>0</div>
                                    <div>Vacancy</div>
                                </div>
                            </div>
                        </div>
                        <div className='infoLine'></div>
                        <div className='jobPostingsCardButtonBox'>
                            <div className='jobPostingsButton' onClick={() => jump('/partner/wapList')}>
                                <img src={studentImg} />Student
                                <div className='studentSpan'>1</div>
                            </div>
                            <div className='jobPostingsButton'>
                                <img src={inspectImg} />Show Detail
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
                {Base.isEmpty(draftList) && Base.isEmpty(submittedList) && Base.isEmpty(activeList) ? <Empty /> : ''}
                {draftList.length > 0 ?
                    <>
                        <div className='flexBoxMax'>
                            <div className='statusTitleBox homeStatusMargin DRAFT' onClick={() => jump('/partner/partnerSeeAllJobPosting/DRAFT')}>
                                Draft
                            </div>
                        </div>
                        <div className='carouselCardBoxRow'>
                            {draftList.length > 1 ?
                                <div className='arrowBox'>
                                    <div className='arrow' onClick={() => carouselRef.current.prev()}><img src={leftArrow} /></div>
                                </div>
                                :
                                <div className='arrowBox'></div>
                            }
                            <Carousel ref={carouselRef} autoplay={false} dots={false}>
                                {draftList?.map((item, index) =>
                                    <div className='carouselCardBox' key={index}>
                                        {item.map(item =>
                                            <div key={item.jobId} className='cardBoxDiv borderColorDRAFT'>
                                                <div className='cardProgrammeRow'>
                                                    <div className='cardProgrammeBox' title={item.progTitle}>
                                                        <div className='cardProgrammeText'>{item.progTitle}</div>
                                                    </div>
                                                </div>
                                                <div className='cardTitleBox'>
                                                    <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Job ID</div>
                                                    <div className='value'>
                                                        {item.jobId}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Job Mode</div>
                                                    <div className='value'>
                                                        {item.positionTypeVal}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Commence-End</div>
                                                    <div className='value'>
                                                        {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Application Deadline</div>
                                                    <div className='value'>
                                                        {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                                    </div>
                                                </div>
                                                <div className='cardLine'></div>
                                                <div className='cardButtonBox'>
                                                    <Button icon={<img src={deleteIcon} />} className='cardButton' onClick={() => deleteJob(item)}>Delete</Button>
                                                    <Button icon={<img src={duplicateImg} />} className='cardButton' onClick={() => jumpDuplicate(item.jobId)}>Duplicate</Button>
                                                    <Dropdown trigger={['hover']}
                                                        placement="bottomLeft"
                                                        destroyPopupOnHide={true}
                                                        // getPopupContainer={() => document.getElementById("jobPostDetail"+item.jobId)}
                                                        dropdownRender={() =>
                                                            <div>
                                                                <Button icon={<img src={fillImg} />} onClick={() => jump('/partner/partnerJobPostingDetail/' + item.jobId + '/edit')}>
                                                                    Edit
                                                                </Button>
                                                                <Button icon={<img src={select3} />} disabled={isLoad} onClick={() => saveSubmit(item)}>
                                                                    Submit
                                                                </Button>
                                                            </div>
                                                        }
                                                    >
                                                        <Button id={"jobPostDetail" + item.jobId} icon={<img src={inspectImg} />} className='cardButton'>
                                                            Action
                                                        </Button>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Carousel>
                            {draftList.length > 1 &&
                                <div className='arrowBox'>
                                    <div className='arrow' onClick={() => draftHandleSwitch()}><img src={rightArrow} /></div>
                                </div>
                            }
                        </div>
                    </>
                    : null}

                {submittedList.length > 0 ?
                    <>
                        <div className='flexBoxMax'>
                            <div className='statusTitleBox homeStatusMargin SUBMITTED' onClick={() => jump('/partner/partnerSeeAllJobPosting/SUBMITTED')}>
                                THEi Reviewing
                            </div>
                        </div>
                        <div className='carouselCardBoxRow'>
                            {submittedList.length > 1 ?
                                <div className='arrowBox'>
                                    <div className='arrow' onClick={() => carouselRef2.current.prev()}><img src={leftArrow} /></div>
                                </div>
                                :
                                <div className='arrowBox'></div>
                            }
                            <Carousel ref={carouselRef2} autoplay={false} dots={false}>
                                {submittedList?.map((item, index) =>
                                    <div className='carouselCardBox' key={index}>
                                        {item.map(item =>
                                            <div key={item.jobId} className='cardBoxDiv borderColorSUBMITTED'>
                                                <div className='cardProgrammeRow'>
                                                    <div className='cardProgrammeBox' title={item.progTitle}>
                                                        <div className='cardProgrammeText'>{item.progTitle}</div>
                                                    </div>
                                                </div>
                                                <div className='cardTitleBox'>
                                                    <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Job ID</div>
                                                    <div className='value'>
                                                        {item.jobId}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Job Mode</div>
                                                    <div className='value'>
                                                        {item.positionTypeVal}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Commence-End</div>
                                                    <div className='value'>
                                                        {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Application Deadline</div>
                                                    <div className='value'>
                                                        {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                                    </div>
                                                </div>
                                                <div className='cardLine'></div>
                                                <div className='cardButtonBox'>
                                                    <Button icon={<img src={duplicateImg} />} className='cardButton' onClick={() => jumpDuplicate(item.jobId)}>Duplicate</Button>
                                                    <Dropdown trigger={['hover']}
                                                        placement="bottomLeft"
                                                        destroyPopupOnHide={true}
                                                        // getPopupContainer={() => document.getElementById("jobPostDetail"+item.jobId)}
                                                        dropdownRender={() =>
                                                            <div>
                                                                <Button icon={<img src={fillImg} />} onClick={() => jump('/partner/partnerJobPostingDetail/' + item.jobId + '/edit')}>
                                                                    Edit
                                                                </Button>
                                                                <Button icon={<img src={select5} />} disabled={isLoad} onClick={() => messageConfirmShow(withdrawnMessage, item)}>
                                                                    Withdrawn
                                                                </Button>
                                                            </div>
                                                        }
                                                    >
                                                        <Button id={"jobPostDetail" + item.jobId} icon={<img src={inspectImg} />} className='cardButton'>
                                                            Action
                                                        </Button>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Carousel>
                            {submittedList.length > 1 &&
                                <div className='arrowBox'>
                                    <div className='arrow' onClick={() => submittedHandleSwitch()}><img src={rightArrow} /></div>
                                </div>
                            }
                        </div>
                    </>
                    : null}

                {activeList.length > 0 ?
                    <>
                        <div className='flexBoxMax'>
                            <div className='statusTitleBox homeStatusMargin ACTIVE' style={{ backgroundColor: '#008B00', color: '#E9F8E9' }} onClick={() => jump('/partner/partnerSeeAllJobPosting/ACTIVE')}>
                                Active
                            </div>
                        </div>
                        <div className='carouselCardBoxRow'>
                            {activeList.length > 1 ?
                                <div className='arrowBox'>
                                    <div className='arrow' onClick={() => carouselRef3.current.prev()}><img src={leftArrow} /></div>
                                </div>
                                :
                                <div className='arrowBox'></div>
                            }
                            <Carousel ref={carouselRef3} autoplay={false} dots={false}>
                                {activeList?.map((item, index) =>
                                    <div className='carouselCardBox' key={index}>
                                        {item.map(item =>
                                            <div key={item.jobId} className='cardBoxDiv borderColorACTIVE'>
                                                <div className='cardProgrammeRow'>
                                                    <div className='cardProgrammeBox' title={item.progTitle}>
                                                        <div className='cardProgrammeText'>{item.progTitle}</div>
                                                    </div>
                                                    {
                                                        item.specialArrange === 'Y' &&
                                                        <div className='cardProgrammeBox' style={{ backgroundColor: '#008B00', color: '#E9F8E9' }}>
                                                            <div className='cardProgrammeText'>Special Arrangement</div>
                                                        </div>
                                                    }
                                                </div>
                                                <div className='cardTitleBox'>
                                                    <div className='cardTitle' title={item.jobTitle}>{item.jobTitle}</div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Job ID</div>
                                                    <div className='value'>
                                                        {item.jobId}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Job Mode</div>
                                                    <div className='value'>
                                                        {item.positionTypeVal}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Commence-End</div>
                                                    <div className='value'>
                                                        {item.expCommenceDate ? moment(item.expCommenceDate).format(Config.dateFormatEn) : ''} ~ {item.expEndDate ? moment(item.expEndDate).format(Config.dateFormatEn) : ''}
                                                    </div>
                                                </div>
                                                <div className='flexBox'>
                                                    <div className='label'>Application Deadline</div>
                                                    <div className='value'>
                                                        {item.lastApplyDate ? moment(item.lastApplyDate).format(Config.dateFormatEn) : ''}
                                                    </div>
                                                </div>
                                                <div className='cardLine'></div>
                                                <div className='cardButtonBox'>
                                                    <Button icon={<img src={studentImg} />} className='cardButton' onClick={() => jump('/partner/studentApplications/' + item.jobId)}>
                                                        Student{item.studentNum > 0 && <div className='studentSpan'>{item.studentNum}</div>}
                                                    </Button>
                                                    <Button icon={<img src={duplicateImg} />} className='cardButton' onClick={() => jumpDuplicate(item.jobId)}>Duplicate</Button>
                                                    <Dropdown trigger={['hover']}
                                                        placement="bottomLeft"
                                                        destroyPopupOnHide={true}
                                                        // getPopupContainer={() => document.getElementById("jobPostDetail"+item.jobId)}
                                                        dropdownRender={() =>
                                                            <div>
                                                                <Button icon={<img src={select1} />} onClick={() => jump('/partner/partnerJobPostingDetail/' + item.jobId + '/view')}>
                                                                    Show Detail
                                                                </Button>
                                                                <Button icon={<img src={select5} />} disabled={isLoad} onClick={() => messageConfirmShow(withdrawnMessage, item)}>
                                                                    Withdrawn
                                                                </Button>
                                                            </div>
                                                        }
                                                    >
                                                        <Button id={"jobPostDetail" + item.jobId} icon={<img src={inspectImg} />} className='cardButton'>
                                                            Action
                                                        </Button>
                                                    </Dropdown>
                                                </div>
                                            </div>
                                        )}
                                    </div>
                                )}
                            </Carousel>
                            {activeList.length > 1 &&
                                <div className='arrowBox'>
                                    <div className='arrow' onClick={() => activeHandleSwitch()}><img src={rightArrow} /></div>
                                </div>
                            }
                        </div>
                    </>
                    : null}
                <div className='flexTitleBox'>
                    <div className='homeTitle jobApplicationsBox'>
                        Job Applications in Processing
                        <Popover placement="bottom" content={
                            <div style={{ maxWidth: "500px", textAlign: 'justify' }}>
                                {'This section showcases applications currently under review, along with their corresponding statuses: Pend IP Receipt, IP Processing, IP Request More Info, Student Updated Info, IP Made Offer. To access a comprehensive and cumulative list of all applications, please click on "See All Applications".'}
                            </div>
                        } trigger="hover" >
                            <div className='questionCircle' ><QuestionCircleOutlined /></div>
                        </Popover>
                    </div>
                    <div className='seeAllBox' onClick={() => jump('/partner/partnerSeeAllApplications/all')}>See all applications</div>
                </div>
                <div className="sysTable" id="tableOne">
                    <Table
                        scroll={{ x: 1200 }}
                        rowKey="jobApplId"
                        columns={columns} //列名
                        dataSource={tables} //数据
                        pagination={{  //分页
                            showSizeChanger: true,          //是否显示可以设置几条一页的选项
                            onChange: onChange,            //上页下页或者跳页方法
                            onShowSizeChange: onShowSizeChange,    //每页显示多少条数据方法
                            total: tablesCount,             //总共多少条数据
                            current: current,         //当前页
                            pageSize: pageSize,       //每页显示多少条数据
                            defaultCurrent: 1,        //默认当前页为1
                            size: "small"
                        }}
                        onChange={handleTableChange}
                    />
                </div>
            </Spin>
        </div>
    )

}

export default PartnerHome;